/**
 * Coming Soon Route Configuration
 * 
 * OCP-Compliant route blocking strategy.
 * This configuration can be extended without modifying ComingSoonGate.
 */

export interface RouteBlockingConfig {
  /**
   * Routes that are always allowed when Coming Soon is enabled
   * These routes bypass the Coming Soon page
   */
  allowedRoutes: string[]
  
  /**
   * Routes that require admin authentication to bypass Coming Soon
   * These routes are blocked unless user is authenticated admin
   */
  adminOnlyRoutes: string[]
  
  /**
   * Routes that should redirect to home (/) instead of showing Coming Soon
   * Useful for routes that should appear as "not found" when blocked
   */
  redirectToHomeRoutes: string[]
}

/**
 * Default route blocking configuration
 * Can be extended or overridden without modifying ComingSoonGate
 */
export const defaultComingSoonRouteConfig: RouteBlockingConfig = {
  // Only the Coming Soon page itself is allowed
  allowedRoutes: ['/coming-soon'],
  
  // Admin routes require admin authentication to bypass
  adminOnlyRoutes: ['/admin'],
  
  // All other routes (including /login, /register, etc.) redirect to home
  redirectToHomeRoutes: ['/login', '/register', '/forgot-password', '/reset-password']
}

/**
 * Check if a route matches any pattern in the allowed routes list
 */
export const isRouteAllowed = (pathname: string, config: RouteBlockingConfig): boolean => {
  return config.allowedRoutes.some(route => 
    pathname === route || pathname.startsWith(route + '/')
  )
}

/**
 * Check if a route requires admin authentication
 */
export const isAdminOnlyRoute = (pathname: string, config: RouteBlockingConfig): boolean => {
  return config.adminOnlyRoutes.some(route => 
    pathname.startsWith(route)
  )
}

/**
 * Check if a route should redirect to home when blocked
 */
export const shouldRedirectToHome = (pathname: string, _config: RouteBlockingConfig): boolean => {
  // Always redirect non-home routes to home
  // Config parameter kept for future extensibility (OCP)
  return pathname !== '/'
}
